module.exports = __webpack_public_path__ + "img/clip_image034.5bde7e00.png";